import { Component, OnDestroy, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs';

import { FormComponent } from './app.form.component';
import { MenuConfig } from './app.menu.config';
import { BreadcrumbService } from '../framework/breadcrumb.service';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { AutenticacaoGhubService } from 'src/app/homecare/gis/ghub/autenticacao-ghub.service';
import { MenuItemCustom } from '../framework/MenuItemCustom.interface';
import { environment } from 'src/environments/environment';
import { ConfirmacaoService } from '../confirmacao/confirmacao.service';
import { AppComponent } from 'src/app/app.component';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TopbarFilterHandlerService } from '../framework/filters/topbar-filter/service/topbar-filter-handler.service';
import { TopbarItemEventDTO } from '../framework/filters/topbar-filter/model/dto/TopbarItemEvent.dto';
import { TopbarFilterController } from '../framework/filters/topbar-filter/topbar-filter-controller.interface';
import { ToasterService } from '../framework/toaster/toaster.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html'
})
export class AppBreadcrumbComponent implements OnDestroy, AfterViewChecked {

    public caminhoPaginaInicial: string;

    subscription: Subscription;
    menuConfigSubscription: Subscription;

    items: MenuItemCustom[];
    formComponent: FormComponent;

    formMenuItems: MenuItemCustom[];
    menuConfig: MenuConfig;

    topbarFilterSubscription: Subscription;

    constructor(
      public breadcrumbService: BreadcrumbService
      , public app: AppComponent
      , private autenticacaoService: AutenticacaoService
      , private autenticacaoGhubService: AutenticacaoGhubService
      , private changeDetectorRef: ChangeDetectorRef
      , private location: Location
      , private confirmacaoService: ConfirmacaoService
      , private router: Router
      , private topbarFilterHandlerService: TopbarFilterHandlerService
      , private toasterService: ToasterService
    ) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
            this.changeDetectorRef.detectChanges();
        });

        this.menuConfigSubscription = breadcrumbService.menuConfigHandler.subscribe(response => {
            this.menuConfig = response;
            if (this.menuConfig) {
                this.formComponent = this.menuConfig.getContext();
            }

            this.menuConfig.setChangeDetectorRef(this.changeDetectorRef);
        });

        this.caminhoPaginaInicial = environment.caminho_pagina_inicial;

        this.router
            .events
            .subscribe((event:NavigationStart) => {
              if ( event instanceof NavigationEnd ) {
                this.app.hideTopbarFilter();
              }
            });
    }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
      if (this.subscription) {
          this.subscription.unsubscribe();
      }
      if (this.menuConfigSubscription) {
          this.menuConfigSubscription.unsubscribe();
      }

      this.formComponent = null;
      if (this.menuConfig) {
          this.menuConfig.destroy();
      }

      if ( this.topbarFilterSubscription ) {
        this.topbarFilterSubscription.unsubscribe();
      }

      if ( this.menuConfig ) {
        this.menuConfig.setChangeDetectorRef(null);
      }
  }

  informarFaltaDoContexto(): void {
    this.toasterService.error('Pode ter ocorrido uma falha no sistema', 'O contexto do formulário não foi definido.');
  }

  imprimir() {
    window.print();
  }

  salvar() {
      if (this.formComponent) {
          if (this.formComponent.pId > 0) {
              this.confirmacaoService.confirmarAtualizacao(() => {
                  this.formComponent.atualizar();
              });
          }
          else {
              this.confirmacaoService.confirmarAtualizacao(() => {
                  this.formComponent.inserir();
              });
          }
      }
      else {
        this.informarFaltaDoContexto();
      }
  }

  novo() {
      if (this.formComponent) {
          this.confirmacaoService.confirmarAtualizacao(() => {
              this.formComponent.inserir();
          });
      }
      else {
        this.informarFaltaDoContexto();
      }
  }

  excluir() {
    if (this.formComponent) {
      this.confirmacaoService.confirmarExclusao(() => {
          this.formComponent.excluir();
      });
    }
    else {
      this.informarFaltaDoContexto();
    }
  }

  voltar() {
    this.location.back();
  }

  logout() {
    this.autenticacaoService.logout();
    this.autenticacaoGhubService.logout();
  }

  filtrar(controller: TopbarFilterController) {

    // ESCONDER
    if ( this.app.isTopbarFilterVisible() ) {
      this.app.hideTopbarFilter();

      if ( this.topbarFilterSubscription ) {
        this.topbarFilterSubscription.unsubscribe();
      }
    }

    // EXIBIR
    else {
      const topbarFilters = controller.getTopbarFilters();

      this.app.showTopbarFilter();


      setTimeout(() => {
        // adicionar os topbar-itens na topbar
        this.topbarFilterHandlerService
            .getAddFilterInTopbarSubjectSingleton()
            .next({filtros: topbarFilters});

        // acoplar o observer do controller no emissor ( subject ) no handler service
        this.topbarFilterSubscription = this.topbarFilterHandlerService
                                            .getTopbarAllFiltersSubject()
                                            .subscribe((itensEventoDTO: TopbarItemEventDTO[]) => {
                                              controller.topbarFilterOnChange(itensEventoDTO);
                                            });
      });
    }

    this.changeDetectorRef.detectChanges();
  }
}
